import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-75">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-6 leading-tight" data-id="element-77">
          Tu vocación es acompañar.
          <br data-id="element-78" />
          <span className="text-gold-gradient" data-id="element-79">
            No ser un administrativo esclavo de la burocracia.
          </span>
        </h2>

        <p className="text-xl text-[#e2e8f0] mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-80">
          El Método Elite AT te devuelve el tiempo, la seguridad y la autoridad
          profesional que tu trabajo merece.
        </p>

        <div className="flex flex-col items-center gap-6 mb-12" data-id="element-81">
          <motion.a href="https://fegion.shop/cart/46280115159179:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              value: 29990,
              currency: 'ARS',
              content_name: 'Combo Elite AT'
            });
          }
        }} className="w-full max-w-md py-5 px-8 bg-[#FFD700] text-[#0a1628] rounded-full font-bold text-xl gold-glow-strong hover:brightness-110 transition-all shadow-xl" data-id="element-82">
            → EMPEZAR HOY — $29.990
          </motion.a>

          <span className="text-[#a0aec0] italic" data-id="element-83">— o —</span>

          <a href="https://fegion.shop/cart/46280111620235:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              value: 19990,
              currency: 'ARS',
              content_name: 'Pack Base AT'
            });
          }
        }} className="text-[#e2e8f0] hover:text-white border-b border-[#e2e8f0]/30 hover:border-white transition-colors pb-1" data-id="element-84">
            → Solo el Pack Base — $19.990 ←
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-[#a0aec0] mb-16" data-id="element-85">
          <span className="flex items-center gap-2" data-id="element-86">
            <Check className="w-4 h-4 text-green-400" data-id="element-87" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-88">
            <Check className="w-4 h-4 text-green-400" data-id="element-89" /> 100% PDF
          </span>
          <span className="flex items-center gap-2" data-id="element-90">
            <Check className="w-4 h-4 text-green-400" data-id="element-91" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-92">
            <Check className="w-4 h-4 text-green-400" data-id="element-93" /> Tuyo de por vida
          </span>
        </div>

        <div className="pt-8 border-t border-[#1a2b4c]" data-id="element-94">
          <p className="text-2xl font-bold text-white font-heading tracking-widest mb-2" data-id="element-95">
            MÉTODO ELITE AT
          </p>
          <p className="text-[#a0aec0]" data-id="element-96">
            Para el Acompañante Terapéutico que trabaja en serio.
          </p>
        </div>
      </motion.div>
    </section>;
}